export default __webpack_public_path__ + "static/media/c002-PPII-11.7c62da2b.svg";